module.exports = __webpack_public_path__ + "img/3.29c3a078.jpg";